export default function Resources() {
  return (
    <div className="bg-white shadow rounded-lg p-6">
      <h2 className="text-xl font-semibold mb-4">📚 Learning Resources</h2>
      <p>Documents, tutorials, and videos shared by mentors.</p>
    </div>
  );
}
